<template>
    <div class="CMasonryNetworkBannerCard">
        <div class="banner-content rounded-xl bg-[#eef9f0] p-6 shadow-md h-full flex flex-col">
            <h2 class="mb-3 text-xl font-bold text-[#2E1943]">
                Mentoringový network pre svetové Slovensko
            </h2>
            <p class="mb-4 text-sm leading-relaxed text-[#2E1943]">
                Výberový mentoringový program pre ľudí, ktorí chcú posúvať seba, svoje organizácie a Slovensko vpred.
            </p>
            <NuxtLink
                to="/mentoring-network-pre-svetove-slovensko"
                class="w-full rounded-lg bg-[#C68DFF] hover:bg-[#B47DE6] px-4 py-2.5 text-center text-sm font-semibold text-white transition-all mt-auto"
            >
                Zistiť viac
            </NuxtLink>
        </div>
    </div>
</template>

<style scoped>
.CMasonryNetworkBannerCard {
    border-radius: 5px;
    opacity: 100%;
    background-color: transparent;
    width: 100%;
    min-width: 12.5rem;
    min-height: 280px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.banner-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>
